import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "user-roles" }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-sm-9" }
const _hoisted_4 = { class: "text-sm-right col-sm-3" }
const _hoisted_5 = {
  key: 0,
  class: "text-center mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BListGroupItem = _resolveComponent("BListGroupItem")!
  const _component_BListGroup = _resolveComponent("BListGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.readOnly)
          ? (_openBlock(), _createBlock(_component_BButton, {
              key: 0,
              disabled: _ctx.disabled,
              class: "pull-right",
              size: "sm",
              variant: "light",
              onClick: _ctx.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: "plus" })
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.data && _ctx.data.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("formList.nothingToShow")), 1))
      : (_openBlock(), _createBlock(_component_BListGroup, { key: 1 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
              return (_openBlock(), _createBlock(_component_BListGroupItem, {
                key: item['id'] ?? undefined,
                class: "d-flex justify-content-between align-items-center"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "itemTemplate", { item: item }, () => [
                    _createTextVNode(_toDisplayString(item == undefined ? undefined : item[_ctx.textField]), 1)
                  ]),
                  (!_ctx.readOnly)
                    ? (_openBlock(), _createBlock(_component_BButton, {
                        key: 0,
                        size: "sm",
                        variant: "outline-light",
                        onClick: ($event: any) => (_ctx.remove(item?.[_ctx.idField ?? 0]))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "minus" })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 3
        }))
  ]))
}